import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Cursor for paging through collections */
  ConnectionCursor: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONString: object;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  MyDateTime: Date;
};

export enum AutoPredictorMode {
  Disabled = 'Disabled',
  FinishProcessing = 'FinishProcessing',
  ForceVerification = 'ForceVerification',
  PredictAllChildren = 'PredictAllChildren'
}

export type AxisAlignedRectangle = {
  __typename?: 'AxisAlignedRectangle';
  height: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type AxisAlignedRectangleInput = {
  height: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type BlindProcessingThreshold = {
  __typename?: 'BlindProcessingThreshold';
  confirmedness: Scalars['Float'];
  score: Scalars['Float'];
};

export type BlindProcessingThresholdInput = {
  confirmedness: Scalars['Float'];
  score: Scalars['Float'];
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDocumentSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: DocumentSubscriptionFilter;
};

export type CreateLogSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: LogSubscriptionFilter;
};

export type CreatePredictionSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: PredictionSubscriptionFilter;
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']>;
};

export enum DataType {
  None = 'None',
  String = 'String',
  StringMultiline = 'StringMultiline'
}

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime'];
  upper: Scalars['DateTime'];
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int'];
};

export type DeleteOneDocumentSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: DocumentSubscriptionFilter;
};

export type DeleteOneLogSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: LogSubscriptionFilter;
};

export type DeleteOnePredictionSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: PredictionSubscriptionFilter;
};

export type Document = {
  __typename?: 'Document';
  /** Whether this document should be used for training, validation or testing. Calculated from the root document id with a 6:1:1 ratio.  */
  bucket: SampleBucket;
  children?: Maybe<Array<Document>>;
  comments?: Maybe<Scalars['String']>;
  created: Scalars['MyDateTime'];
  document_class?: Maybe<DocumentClass>;
  document_class_identifier: Scalars['String'];
  document_value?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Document>>;
  id: Scalars['String'];
  /** whether this document is currently locked or not */
  locked: Scalars['Boolean'];
  /** Time at which this document was last locked. Please do not use this field to find out if the document is currently locked; use `locked` instead. */
  locked_at?: Maybe<Scalars['MyDateTime']>;
  /** user id (i.e. email) that currently holds the lock on this document */
  locked_by?: Maybe<Scalars['String']>;
  /** Time until which this document was last locked. Please do not use this field to find out if the document is currently locked; use `locked` instead. */
  locked_until?: Maybe<Scalars['MyDateTime']>;
  metadata?: Maybe<Scalars['JSONString']>;
  organization_id: Scalars['String'];
  pages: Array<Page>;
  parent_document?: Maybe<Document>;
  parent_document_id?: Maybe<Scalars['String']>;
  parent_upload?: Maybe<Upload>;
  prediction?: Maybe<Prediction>;
  /** confirmedness of this document's prediction (if any) in order to be able to filter on it */
  prediction_confirmedness?: Maybe<Scalars['Float']>;
  raw_bytes: Scalars['String'];
  raw_json: Scalars['JSONString'];
  root_document?: Maybe<Document>;
  root_document_id: Scalars['String'];
  scope: Scope;
  /** A comment regarding the snooze. */
  snooze_comment?: Maybe<Scalars['String']>;
  /** Users that are tagged, when you snooze a document. */
  snooze_tag_users?: Maybe<Array<Scalars['String']>>;
  /** Time at which this document was last snoozed. */
  snoozed_at?: Maybe<Scalars['MyDateTime']>;
  /** user id (i.e. email) that snoozed the document last. */
  snoozed_by?: Maybe<Scalars['String']>;
  source?: Maybe<SourceChannel>;
  source_prediction?: Maybe<Prediction>;
  source_prediction_pages?: Maybe<Array<PredictedPage>>;
  state: DocumentState;
  storage_subdir: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  /** The topic where the events of this document belong. Determined at document creation time. */
  topic: Scalars['String'];
  updated: Scalars['MyDateTime'];
  verification_sent?: Maybe<Scalars['Boolean']>;
};


export type DocumentChildrenArgs = {
  filter?: InputMaybe<DocumentFilter>;
  sorting?: InputMaybe<Array<DocumentSort>>;
};


export type DocumentDocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  sorting?: InputMaybe<Array<DocumentSort>>;
};

export type DocumentAggregateGroupBy = {
  __typename?: 'DocumentAggregateGroupBy';
  bucket?: Maybe<SampleBucket>;
  created?: Maybe<Scalars['MyDateTime']>;
  document_class_identifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  locked_at?: Maybe<Scalars['MyDateTime']>;
  locked_by?: Maybe<Scalars['String']>;
  locked_until?: Maybe<Scalars['MyDateTime']>;
  organization_id?: Maybe<Scalars['String']>;
  parent_document_id?: Maybe<Scalars['String']>;
  prediction_confirmedness?: Maybe<Scalars['Float']>;
  root_document_id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scope>;
  snoozed_at?: Maybe<Scalars['MyDateTime']>;
  snoozed_by?: Maybe<Scalars['String']>;
  source?: Maybe<SourceChannel>;
  state?: Maybe<DocumentState>;
  title?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  verification_sent?: Maybe<Scalars['Boolean']>;
};

export type DocumentAvgAggregate = {
  __typename?: 'DocumentAvgAggregate';
  prediction_confirmedness?: Maybe<Scalars['Float']>;
};

export type DocumentClass = {
  __typename?: 'DocumentClass';
  always_include_in_blind_processing_decision: Scalars['Boolean'];
  auto_predictor_mode: AutoPredictorMode;
  blind_processing_thresholds?: Maybe<Array<BlindProcessingThreshold>>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created: Scalars['MyDateTime'];
  deleted_at?: Maybe<Scalars['MyDateTime']>;
  description?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
  export_enabled?: Maybe<Scalars['Boolean']>;
  export_parallelization?: Maybe<Scalars['Float']>;
  export_queue?: Maybe<Scalars['String']>;
  export_timeout?: Maybe<Scalars['Float']>;
  exporter_settings?: Maybe<Scalars['JSONString']>;
  /** See https://ng-alain.com/form/getting-started/en for more information about the schema definitions. */
  exporter_settings_schema?: Maybe<Scalars['JSONString']>;
  /** unique identifier of this document class. Consists of the local identifiers of all parent classes, separated with a slash. Also needs to begin with a slash. Cannot be directly set. */
  identifier: Scalars['String'];
  identifier_by_organization?: Maybe<Scalars['String']>;
  local_identifier: Scalars['String'];
  /** Should not be set when there is no parent. */
  max_count?: Maybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  max_page_count?: Maybe<Scalars['Int']>;
  may_overlap_with_siblings?: Maybe<Scalars['Boolean']>;
  /** Should not be set when there is no parent. */
  min_count?: Maybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  min_page_count?: Maybe<Scalars['Int']>;
  /** Sorting parameter */
  order_weight?: Maybe<Scalars['Float']>;
  organization_id: Scalars['ID'];
  /** Global identifier of this document's parent class */
  parent_id?: Maybe<Scalars['String']>;
  /** info about the possible data that documents of this type may containImportant: In the end we read out what's there; incl. typos and so on.Postprocessing should be applied in the exporter.Therefore, the document's value is always a string (or nothing) */
  possible_value?: Maybe<DataType>;
  prediction_queue?: Maybe<Scalars['String']>;
  regex_validators: Array<RegexValidator>;
  search_keywords?: Maybe<Array<Scalars['String']>>;
  /** This field can be used to determine e.g. what kind of UI to show to the user (for the parent document class) If all child classes of a given class have selection mode "Parent", then show a simple classification UI. Similarly: All are "Pages" / "SinglePage" then show page classification. All are "Cutout", then do extraction. Mixed selection modes in the children (or all are "Anything") should probably result in an error message. */
  selection_mode: SelectionMode;
  updated: Scalars['MyDateTime'];
};

export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  /** Array of edges. */
  edges: Array<DocumentEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type DocumentCountAggregate = {
  __typename?: 'DocumentCountAggregate';
  bucket?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  document_class_identifier?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locked?: Maybe<Scalars['Int']>;
  locked_at?: Maybe<Scalars['Int']>;
  locked_by?: Maybe<Scalars['Int']>;
  locked_until?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  parent_document_id?: Maybe<Scalars['Int']>;
  prediction_confirmedness?: Maybe<Scalars['Int']>;
  root_document_id?: Maybe<Scalars['Int']>;
  scope?: Maybe<Scalars['Int']>;
  snoozed_at?: Maybe<Scalars['Int']>;
  snoozed_by?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  topic?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
  verification_sent?: Maybe<Scalars['Int']>;
};

export type DocumentDeleteResponse = {
  __typename?: 'DocumentDeleteResponse';
  /** Whether this document should be used for training, validation or testing. Calculated from the root document id with a 6:1:1 ratio.  */
  bucket?: Maybe<SampleBucket>;
  comments?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  document_class_identifier?: Maybe<Scalars['String']>;
  document_value?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** whether this document is currently locked or not */
  locked?: Maybe<Scalars['Boolean']>;
  /** Time at which this document was last locked. Please do not use this field to find out if the document is currently locked; use `locked` instead. */
  locked_at?: Maybe<Scalars['MyDateTime']>;
  /** user id (i.e. email) that currently holds the lock on this document */
  locked_by?: Maybe<Scalars['String']>;
  /** Time until which this document was last locked. Please do not use this field to find out if the document is currently locked; use `locked` instead. */
  locked_until?: Maybe<Scalars['MyDateTime']>;
  metadata?: Maybe<Scalars['JSONString']>;
  organization_id?: Maybe<Scalars['String']>;
  pages?: Maybe<Array<Page>>;
  parent_document_id?: Maybe<Scalars['String']>;
  parent_upload?: Maybe<Upload>;
  /** confirmedness of this document's prediction (if any) in order to be able to filter on it */
  prediction_confirmedness?: Maybe<Scalars['Float']>;
  root_document_id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scope>;
  /** A comment regarding the snooze. */
  snooze_comment?: Maybe<Scalars['String']>;
  /** Users that are tagged, when you snooze a document. */
  snooze_tag_users?: Maybe<Array<Scalars['String']>>;
  /** Time at which this document was last snoozed. */
  snoozed_at?: Maybe<Scalars['MyDateTime']>;
  /** user id (i.e. email) that snoozed the document last. */
  snoozed_by?: Maybe<Scalars['String']>;
  source?: Maybe<SourceChannel>;
  source_prediction_pages?: Maybe<Array<PredictedPage>>;
  state?: Maybe<DocumentState>;
  storage_subdir?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The topic where the events of this document belong. Determined at document creation time. */
  topic?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  verification_sent?: Maybe<Scalars['Boolean']>;
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Document */
  node: Document;
};

export type DocumentFilter = {
  and?: InputMaybe<Array<DocumentFilter>>;
  bucket?: InputMaybe<SampleBucketFilterComparison>;
  created?: InputMaybe<DateFieldComparison>;
  document_class_identifier?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locked?: InputMaybe<BooleanFieldComparison>;
  locked_at?: InputMaybe<DateFieldComparison>;
  locked_by?: InputMaybe<StringFieldComparison>;
  locked_until?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<DocumentFilter>>;
  organization_id?: InputMaybe<StringFieldComparison>;
  parent_document_id?: InputMaybe<StringFieldComparison>;
  prediction_confirmedness?: InputMaybe<NumberFieldComparison>;
  root_document_id?: InputMaybe<StringFieldComparison>;
  scope?: InputMaybe<ScopeFilterComparison>;
  snoozed_at?: InputMaybe<DateFieldComparison>;
  snoozed_by?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<SourceChannelFilterComparison>;
  state?: InputMaybe<DocumentStateFilterComparison>;
  title?: InputMaybe<StringFieldComparison>;
  topic?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  verification_sent?: InputMaybe<BooleanFieldComparison>;
};

export type DocumentInformationUpdateInput = {
  comments?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONString']>;
  title: Scalars['String'];
};

export type DocumentMaxAggregate = {
  __typename?: 'DocumentMaxAggregate';
  bucket?: Maybe<SampleBucket>;
  created?: Maybe<Scalars['MyDateTime']>;
  document_class_identifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locked_at?: Maybe<Scalars['MyDateTime']>;
  locked_by?: Maybe<Scalars['String']>;
  locked_until?: Maybe<Scalars['MyDateTime']>;
  organization_id?: Maybe<Scalars['String']>;
  parent_document_id?: Maybe<Scalars['String']>;
  prediction_confirmedness?: Maybe<Scalars['Float']>;
  root_document_id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scope>;
  snoozed_at?: Maybe<Scalars['MyDateTime']>;
  snoozed_by?: Maybe<Scalars['String']>;
  source?: Maybe<SourceChannel>;
  state?: Maybe<DocumentState>;
  title?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type DocumentMinAggregate = {
  __typename?: 'DocumentMinAggregate';
  bucket?: Maybe<SampleBucket>;
  created?: Maybe<Scalars['MyDateTime']>;
  document_class_identifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locked_at?: Maybe<Scalars['MyDateTime']>;
  locked_by?: Maybe<Scalars['String']>;
  locked_until?: Maybe<Scalars['MyDateTime']>;
  organization_id?: Maybe<Scalars['String']>;
  parent_document_id?: Maybe<Scalars['String']>;
  prediction_confirmedness?: Maybe<Scalars['Float']>;
  root_document_id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scope>;
  snoozed_at?: Maybe<Scalars['MyDateTime']>;
  snoozed_by?: Maybe<Scalars['String']>;
  source?: Maybe<SourceChannel>;
  state?: Maybe<DocumentState>;
  title?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type DocumentSort = {
  direction: SortDirection;
  field: DocumentSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DocumentSortFields {
  Bucket = 'bucket',
  Created = 'created',
  DocumentClassIdentifier = 'document_class_identifier',
  Id = 'id',
  Locked = 'locked',
  LockedAt = 'locked_at',
  LockedBy = 'locked_by',
  LockedUntil = 'locked_until',
  OrganizationId = 'organization_id',
  ParentDocumentId = 'parent_document_id',
  PredictionConfirmedness = 'prediction_confirmedness',
  RootDocumentId = 'root_document_id',
  Scope = 'scope',
  SnoozedAt = 'snoozed_at',
  SnoozedBy = 'snoozed_by',
  Source = 'source',
  State = 'state',
  Title = 'title',
  Topic = 'topic',
  Updated = 'updated',
  VerificationSent = 'verification_sent'
}

export enum DocumentState {
  AwaitingBlindProcessingDecision = 'AwaitingBlindProcessingDecision',
  AwaitingExport = 'AwaitingExport',
  AwaitingExportVerification = 'AwaitingExportVerification',
  AwaitingPrediction = 'AwaitingPrediction',
  AwaitingPreprocessing = 'AwaitingPreprocessing',
  AwaitingSeparation = 'AwaitingSeparation',
  AwaitingVerification = 'AwaitingVerification',
  Created = 'Created',
  Deleted = 'Deleted',
  Error = 'Error',
  ExportUnnecessary = 'ExportUnnecessary',
  Exported = 'Exported',
  ExportedFailure = 'ExportedFailure',
  Invalid = 'Invalid',
  Preprocessed = 'Preprocessed',
  Separated = 'Separated',
  Unprocessable = 'Unprocessable'
}

export type DocumentStateFilterComparison = {
  eq?: InputMaybe<DocumentState>;
  gt?: InputMaybe<DocumentState>;
  gte?: InputMaybe<DocumentState>;
  iLike?: InputMaybe<DocumentState>;
  in?: InputMaybe<Array<DocumentState>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<DocumentState>;
  lt?: InputMaybe<DocumentState>;
  lte?: InputMaybe<DocumentState>;
  neq?: InputMaybe<DocumentState>;
  notILike?: InputMaybe<DocumentState>;
  notIn?: InputMaybe<Array<DocumentState>>;
  notLike?: InputMaybe<DocumentState>;
};

export type DocumentSubscriptionFilter = {
  and?: InputMaybe<Array<DocumentSubscriptionFilter>>;
  bucket?: InputMaybe<SampleBucketFilterComparison>;
  created?: InputMaybe<DateFieldComparison>;
  document_class_identifier?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locked?: InputMaybe<BooleanFieldComparison>;
  locked_at?: InputMaybe<DateFieldComparison>;
  locked_by?: InputMaybe<StringFieldComparison>;
  locked_until?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<DocumentSubscriptionFilter>>;
  organization_id?: InputMaybe<StringFieldComparison>;
  parent_document_id?: InputMaybe<StringFieldComparison>;
  prediction_confirmedness?: InputMaybe<NumberFieldComparison>;
  root_document_id?: InputMaybe<StringFieldComparison>;
  scope?: InputMaybe<ScopeFilterComparison>;
  snoozed_at?: InputMaybe<DateFieldComparison>;
  snoozed_by?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<SourceChannelFilterComparison>;
  state?: InputMaybe<DocumentStateFilterComparison>;
  title?: InputMaybe<StringFieldComparison>;
  topic?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  verification_sent?: InputMaybe<BooleanFieldComparison>;
};

export type DocumentSumAggregate = {
  __typename?: 'DocumentSumAggregate';
  prediction_confirmedness?: Maybe<Scalars['Float']>;
};

export type DocumentTypeSeries = {
  __typename?: 'DocumentTypeSeries';
  document_class_identifier: Scalars['ID'];
  total: Scalars['Float'];
  x: Array<Scalars['MyDateTime']>;
  y: Array<Scalars['Float']>;
};

export type EmailChannel = {
  __typename?: 'EmailChannel';
  address?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
};

export type HttpChannel = {
  __typename?: 'HttpChannel';
  endpoint?: Maybe<Scalars['String']>;
  source_address?: Maybe<Scalars['String']>;
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  iLike?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  neq?: InputMaybe<Scalars['ID']>;
  notILike?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
  notLike?: InputMaybe<Scalars['ID']>;
};

export type ImageTransform = {
  __typename?: 'ImageTransform';
  axisAlignedRectangle?: Maybe<AxisAlignedRectangle>;
  perspectiveTransformation?: Maybe<PerspectiveTransformation>;
  rotatedRectangle?: Maybe<RotatedRectangle>;
  rotation?: Maybe<Rotation>;
};

export type ImageTransformInput = {
  axisAlignedRectangle?: InputMaybe<AxisAlignedRectangleInput>;
  perspectiveTransformation?: InputMaybe<PerspectiveTransformationInput>;
  rotatedRectangle?: InputMaybe<RotatedRectangleInput>;
  rotation?: InputMaybe<RotationInput>;
};

export type Log = {
  __typename?: 'Log';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  level: LogLevel;
  msg: Scalars['String'];
  user_email?: Maybe<Scalars['String']>;
};

export type LogAggregateGroupBy = {
  __typename?: 'LogAggregateGroupBy';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
};

export type LogAvgAggregate = {
  __typename?: 'LogAvgAggregate';
  level?: Maybe<Scalars['Float']>;
};

export type LogConnection = {
  __typename?: 'LogConnection';
  /** Array of edges. */
  edges: Array<LogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type LogCountAggregate = {
  __typename?: 'LogCountAggregate';
  context?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  entityClass?: Maybe<Scalars['Int']>;
  entityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
};

export type LogDeleteResponse = {
  __typename?: 'LogDeleteResponse';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
  msg?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['String']>;
};

export type LogEdge = {
  __typename?: 'LogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Log */
  node: Log;
};

export type LogFilter = {
  and?: InputMaybe<Array<LogFilter>>;
  context?: InputMaybe<StringFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  entityClass?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  level?: InputMaybe<LogLevelFilterComparison>;
  or?: InputMaybe<Array<LogFilter>>;
};

export enum LogLevel {
  Debug = 'Debug',
  Error = 'Error',
  Info = 'Info',
  Verbose = 'Verbose',
  Warning = 'Warning'
}

export type LogLevelFilterComparison = {
  eq?: InputMaybe<LogLevel>;
  gt?: InputMaybe<LogLevel>;
  gte?: InputMaybe<LogLevel>;
  iLike?: InputMaybe<LogLevel>;
  in?: InputMaybe<Array<LogLevel>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<LogLevel>;
  lt?: InputMaybe<LogLevel>;
  lte?: InputMaybe<LogLevel>;
  neq?: InputMaybe<LogLevel>;
  notILike?: InputMaybe<LogLevel>;
  notIn?: InputMaybe<Array<LogLevel>>;
  notLike?: InputMaybe<LogLevel>;
};

export type LogMaxAggregate = {
  __typename?: 'LogMaxAggregate';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
};

export type LogMinAggregate = {
  __typename?: 'LogMinAggregate';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
};

export type LogSort = {
  direction: SortDirection;
  field: LogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LogSortFields {
  Context = 'context',
  Created = 'created',
  EntityClass = 'entityClass',
  EntityId = 'entityId',
  Id = 'id',
  Level = 'level'
}

export type LogSubscriptionFilter = {
  and?: InputMaybe<Array<LogSubscriptionFilter>>;
  context?: InputMaybe<StringFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  entityClass?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  level?: InputMaybe<LogLevelFilterComparison>;
  or?: InputMaybe<Array<LogSubscriptionFilter>>;
};

export type LogSumAggregate = {
  __typename?: 'LogSumAggregate';
  level?: Maybe<Scalars['Float']>;
};

export type MenuEntryCount = {
  __typename?: 'MenuEntryCount';
  count: Scalars['Float'];
  identifier: Scalars['String'];
  regex?: Maybe<Scalars['String']>;
  snoozed_count: Scalars['Float'];
  tag_count: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createPrediction: Scalars['String'];
  deletePrediction: Scalars['String'];
  /** Force a state change for some documents. Should only be used in special cases and with caution! */
  forceDocumentStateChange: Array<Scalars['String']>;
  /** Get a list of counts for each menu entry. */
  getAllDocumentCounts: Array<MenuEntryCount>;
  /** trigger a hard deletion of some root documents and all of their children */
  hardDeleteDocuments: Array<Scalars['String']>;
  /** Attempt to lock a document. Returns true iff the locking was successful. */
  lockOneDocument: Scalars['Boolean'];
  /** Mark the export verification as done */
  markExportVerificationSent: Scalars['Boolean'];
  /** Request a reset into AwaitingVerification for some documents. Only possible if the current state is Separated or ExportUnnecessary, and none of the document's children have been exported yet. */
  requestVerificationRetry: Array<Scalars['String']>;
  /** Attempt to snooze a document. Returns true iff the snoozing was successful. */
  snoozeDocument: Scalars['Boolean'];
  /** Issue a soft-delete for some documents and all of its children. */
  softDeleteDocuments: Array<Scalars['String']>;
  /** Attempt to unlock a document. Returns true iff the unlocking was successful. */
  unlockOneDocument: Scalars['Boolean'];
  /** Attempt to unsnooze a document. Returns true iff the unsnoozing was successful. */
  unsnoozeDocument: Scalars['Boolean'];
  updateOneDocumentInformation: Scalars['String'];
};


export type MutationCreatePredictionArgs = {
  document_id: Scalars['String'];
  predictionInput: PredictionInput;
};


export type MutationDeletePredictionArgs = {
  document_id: Scalars['String'];
};


export type MutationForceDocumentStateChangeArgs = {
  desired_state: DocumentState;
  filter: DocumentFilter;
};


export type MutationGetAllDocumentCountsArgs = {
  scope: Scope;
};


export type MutationHardDeleteDocumentsArgs = {
  count: Scalars['Float'];
  filter: DocumentFilter;
};


export type MutationLockOneDocumentArgs = {
  document_id: Scalars['String'];
};


export type MutationMarkExportVerificationSentArgs = {
  document_id: Scalars['String'];
};


export type MutationRequestVerificationRetryArgs = {
  filter: DocumentFilter;
};


export type MutationSnoozeDocumentArgs = {
  document_id: Scalars['String'];
  snooze_comment?: InputMaybe<Scalars['String']>;
  snooze_tag_users?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSoftDeleteDocumentsArgs = {
  filter: DocumentFilter;
};


export type MutationUnlockOneDocumentArgs = {
  document_id: Scalars['String'];
};


export type MutationUnsnoozeDocumentArgs = {
  document_id: Scalars['String'];
};


export type MutationUpdateOneDocumentInformationArgs = {
  document_id: Scalars['String'];
  update: DocumentInformationUpdateInput;
};

export type NetworkShareChannel = {
  __typename?: 'NetworkShareChannel';
  paths: Array<Scalars['String']>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export type OtherChannel = {
  __typename?: 'OtherChannel';
  channel_name: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
};

export type Page = {
  __typename?: 'Page';
  display_path?: Maybe<Scalars['String']>;
  index_in_pdf: Scalars['Int'];
  pdf_path: Scalars['String'];
  png_path: Scalars['String'];
  thumbnail_path: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']>;
};

export type PageInput = {
  display_path?: InputMaybe<Scalars['String']>;
  index_in_pdf: Scalars['Int'];
  pdf_path: Scalars['String'];
  png_path: Scalars['String'];
  thumbnail_path: Scalars['String'];
};

export type PerspectiveTransformation = {
  __typename?: 'PerspectiveTransformation';
  matrix: Array<Scalars['Float']>;
  size: Array<Scalars['Float']>;
};

export type PerspectiveTransformationInput = {
  matrix: Array<Scalars['Float']>;
  size: Array<Scalars['Float']>;
};

export enum PlatformRole {
  Developer = 'Developer',
  Internal = 'Internal',
  PlatformAdmin = 'PlatformAdmin'
}

export type PredictedDocument = {
  __typename?: 'PredictedDocument';
  confidence: Scalars['Float'];
  document_class_identifier: Scalars['String'];
  id: Scalars['String'];
  pages: Array<PredictedPage>;
  prediction?: Maybe<Prediction>;
  value?: Maybe<Scalars['String']>;
};

export type PredictedDocumentInput = {
  confidence: Scalars['Float'];
  document_class_identifier: Scalars['String'];
  id: Scalars['String'];
  pages: Array<PredictedPageInput>;
  prediction?: InputMaybe<PredictionInput>;
  value?: InputMaybe<Scalars['String']>;
};

export type PredictedPage = {
  __typename?: 'PredictedPage';
  source_page: Scalars['Int'];
  transforms?: Maybe<Array<ImageTransform>>;
};

export type PredictedPageInput = {
  source_page: Scalars['Int'];
  transforms?: InputMaybe<Array<ImageTransformInput>>;
};

export type Prediction = {
  __typename?: 'Prediction';
  candidates: Array<PredictionCandidate>;
  confirmedness: Scalars['Float'];
  id: Scalars['String'];
  separated_documents?: Maybe<Array<Document>>;
  source: Scalars['String'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};


export type PredictionSeparated_DocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  sorting?: InputMaybe<Array<DocumentSort>>;
};

export type PredictionAggregateGroupBy = {
  __typename?: 'PredictionAggregateGroupBy';
  confirmedness?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type PredictionAvgAggregate = {
  __typename?: 'PredictionAvgAggregate';
  confirmedness?: Maybe<Scalars['Float']>;
};

export type PredictionCandidate = {
  __typename?: 'PredictionCandidate';
  documents: Array<PredictedDocument>;
  id: Scalars['String'];
  score: Scalars['Float'];
};

export type PredictionCandidateInput = {
  documents: Array<PredictedDocumentInput>;
  id: Scalars['String'];
  score: Scalars['Float'];
};

export type PredictionConnection = {
  __typename?: 'PredictionConnection';
  /** Array of edges. */
  edges: Array<PredictionEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type PredictionCountAggregate = {
  __typename?: 'PredictionCountAggregate';
  confirmedness?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type PredictionDeleteResponse = {
  __typename?: 'PredictionDeleteResponse';
  candidates?: Maybe<Array<PredictionCandidate>>;
  confirmedness?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type PredictionEdge = {
  __typename?: 'PredictionEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Prediction */
  node: Prediction;
};

export type PredictionFilter = {
  and?: InputMaybe<Array<PredictionFilter>>;
  confirmedness?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PredictionFilter>>;
  source?: InputMaybe<StringFieldComparison>;
  user_id?: InputMaybe<StringFieldComparison>;
};

export type PredictionInput = {
  candidates: Array<PredictionCandidateInput>;
};

export type PredictionMaxAggregate = {
  __typename?: 'PredictionMaxAggregate';
  confirmedness?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type PredictionMinAggregate = {
  __typename?: 'PredictionMinAggregate';
  confirmedness?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type PredictionSort = {
  direction: SortDirection;
  field: PredictionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PredictionSortFields {
  Confirmedness = 'confirmedness',
  Id = 'id',
  Source = 'source',
  UserId = 'user_id'
}

export type PredictionSubscriptionFilter = {
  and?: InputMaybe<Array<PredictionSubscriptionFilter>>;
  confirmedness?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PredictionSubscriptionFilter>>;
  source?: InputMaybe<StringFieldComparison>;
  user_id?: InputMaybe<StringFieldComparison>;
};

export type PredictionSumAggregate = {
  __typename?: 'PredictionSumAggregate';
  confirmedness?: Maybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  countDocumentsByClass: Array<DocumentTypeSeries>;
  countTotalDocuments: Array<SimplePoint>;
  document?: Maybe<Document>;
  documents: DocumentConnection;
  log?: Maybe<Log>;
  logs: LogConnection;
  prediction?: Maybe<Prediction>;
  predictions: PredictionConnection;
  /** Contains information about the current offset on the documents topics that this service is at (if it already received an event since the last startup). Use this to check that the information you are querying is up to date. */
  topic_documents: Array<TopicPartitionInformation>;
};


export type QueryCountDocumentsByClassArgs = {
  filter: DocumentFilter;
  sortfield?: InputMaybe<DocumentSort>;
  step: TimeStep;
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryCountTotalDocumentsArgs = {
  filter: DocumentFilter;
  sortfield?: InputMaybe<DocumentSort>;
  step: TimeStep;
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryDocumentArgs = {
  id: Scalars['String'];
};


export type QueryDocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<DocumentSort>>;
};


export type QueryLogArgs = {
  id: Scalars['ID'];
};


export type QueryLogsArgs = {
  filter?: InputMaybe<LogFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<LogSort>>;
};


export type QueryPredictionArgs = {
  id: Scalars['String'];
};


export type QueryPredictionsArgs = {
  filter?: InputMaybe<PredictionFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<PredictionSort>>;
};

export type RegexValidator = {
  __typename?: 'RegexValidator';
  error_message: Scalars['String'];
  pattern: Scalars['String'];
};

export type RegexValidatorInput = {
  error_message: Scalars['String'];
  pattern: Scalars['String'];
};

export type RotatedRectangle = {
  __typename?: 'RotatedRectangle';
  angle: Scalars['Float'];
  centerX: Scalars['Float'];
  centerY: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type RotatedRectangleInput = {
  angle: Scalars['Float'];
  centerX: Scalars['Float'];
  centerY: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type Rotation = {
  __typename?: 'Rotation';
  angle: Scalars['Float'];
};

export type RotationInput = {
  angle: Scalars['Float'];
};

export enum SampleBucket {
  Testing = 'Testing',
  Training = 'Training',
  Validation = 'Validation'
}

export type SampleBucketFilterComparison = {
  eq?: InputMaybe<SampleBucket>;
  gt?: InputMaybe<SampleBucket>;
  gte?: InputMaybe<SampleBucket>;
  iLike?: InputMaybe<SampleBucket>;
  in?: InputMaybe<Array<SampleBucket>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<SampleBucket>;
  lt?: InputMaybe<SampleBucket>;
  lte?: InputMaybe<SampleBucket>;
  neq?: InputMaybe<SampleBucket>;
  notILike?: InputMaybe<SampleBucket>;
  notIn?: InputMaybe<Array<SampleBucket>>;
  notLike?: InputMaybe<SampleBucket>;
};

export enum Scope {
  Development = 'Development',
  HealthCheck = 'HealthCheck',
  Production = 'Production',
  Testing = 'Testing',
  Training = 'Training'
}

export type ScopeFilterComparison = {
  eq?: InputMaybe<Scope>;
  gt?: InputMaybe<Scope>;
  gte?: InputMaybe<Scope>;
  iLike?: InputMaybe<Scope>;
  in?: InputMaybe<Array<Scope>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scope>;
  lt?: InputMaybe<Scope>;
  lte?: InputMaybe<Scope>;
  neq?: InputMaybe<Scope>;
  notILike?: InputMaybe<Scope>;
  notIn?: InputMaybe<Array<Scope>>;
  notLike?: InputMaybe<Scope>;
};

export enum SelectionMode {
  Anything = 'Anything',
  Cutout = 'Cutout',
  Page = 'Page',
  Pages = 'Pages',
  Parent = 'Parent'
}

export type SimplePoint = {
  __typename?: 'SimplePoint';
  x: Scalars['MyDateTime'];
  y: Scalars['Float'];
};

/** Sort Directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export enum SourceChannel {
  EmailChannel = 'EmailChannel',
  HttpChannel = 'HttpChannel',
  NetworkShareChannel = 'NetworkShareChannel',
  OtherChannel = 'OtherChannel'
}

export type SourceChannelFilterComparison = {
  eq?: InputMaybe<SourceChannel>;
  gt?: InputMaybe<SourceChannel>;
  gte?: InputMaybe<SourceChannel>;
  iLike?: InputMaybe<SourceChannel>;
  in?: InputMaybe<Array<SourceChannel>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<SourceChannel>;
  lt?: InputMaybe<SourceChannel>;
  lte?: InputMaybe<SourceChannel>;
  neq?: InputMaybe<SourceChannel>;
  notILike?: InputMaybe<SourceChannel>;
  notIn?: InputMaybe<Array<SourceChannel>>;
  notLike?: InputMaybe<SourceChannel>;
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  iLike?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  notILike?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  notLike?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdDocument: Document;
  createdLog: Log;
  createdPrediction: Prediction;
  deletedManyDocuments: DeleteManyResponse;
  deletedManyLogs: DeleteManyResponse;
  deletedManyPredictions: DeleteManyResponse;
  deletedOneDocument: DocumentDeleteResponse;
  deletedOneLog: LogDeleteResponse;
  deletedOnePrediction: PredictionDeleteResponse;
  updatedManyDocuments: UpdateManyResponse;
  updatedManyLogs: UpdateManyResponse;
  updatedManyPredictions: UpdateManyResponse;
  updatedOneDocument: Document;
  updatedOneLog: Log;
  updatedOnePrediction: Prediction;
};


export type SubscriptionCreatedDocumentArgs = {
  input?: InputMaybe<CreateDocumentSubscriptionFilterInput>;
};


export type SubscriptionCreatedLogArgs = {
  input?: InputMaybe<CreateLogSubscriptionFilterInput>;
};


export type SubscriptionCreatedPredictionArgs = {
  input?: InputMaybe<CreatePredictionSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneDocumentArgs = {
  input?: InputMaybe<DeleteOneDocumentSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneLogArgs = {
  input?: InputMaybe<DeleteOneLogSubscriptionFilterInput>;
};


export type SubscriptionDeletedOnePredictionArgs = {
  input?: InputMaybe<DeleteOnePredictionSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneDocumentArgs = {
  input?: InputMaybe<UpdateOneDocumentSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneLogArgs = {
  input?: InputMaybe<UpdateOneLogSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOnePredictionArgs = {
  input?: InputMaybe<UpdateOnePredictionSubscriptionFilterInput>;
};

export enum TimeStep {
  Annual = 'Annual',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type TopicPartitionInformation = {
  __typename?: 'TopicPartitionInformation';
  offset: Scalars['Float'];
  partition: Scalars['Float'];
  topic: Scalars['String'];
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int'];
};

export type UpdateOneDocumentSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: DocumentSubscriptionFilter;
};

export type UpdateOneLogSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: LogSubscriptionFilter;
};

export type UpdateOnePredictionSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: PredictionSubscriptionFilter;
};

export type Upload = {
  __typename?: 'Upload';
  content_preview?: Maybe<Scalars['String']>;
  identifier_by_organization?: Maybe<Scalars['String']>;
  paths: Array<UploadPath>;
  received_at: Scalars['MyDateTime'];
  source: UploadChannel;
  title?: Maybe<Scalars['String']>;
};

export type UploadChannel = EmailChannel | HttpChannel | NetworkShareChannel | OtherChannel;

export type UploadPath = {
  __typename?: 'UploadPath';
  mime: Scalars['String'];
  original_name?: Maybe<Scalars['String']>;
  path: Scalars['String'];
};

export type UploadPathInput = {
  mime: Scalars['String'];
  original_name?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  last_name?: Maybe<Scalars['String']>;
  login_disabled: Scalars['Boolean'];
  name: Scalars['String'];
  password_hash: Scalars['String'];
  platform_roles: Array<PlatformRole>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type FrontendDocumentClassFragmentFragment = { __typename?: 'DocumentClass', identifier: string, local_identifier: string, identifier_by_organization?: string | null, display_name: string, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, parent_id?: string | null, selection_mode: SelectionMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null };

export type PageFragmentFragment = { __typename?: 'Page', pdf_path: string, thumbnail_path: string, display_path?: string | null, index_in_pdf: number, png_path: string };

export type UploadFragmentFragment = { __typename?: 'Upload', received_at: Date, title?: string | null, content_preview?: string | null, identifier_by_organization?: string | null, paths: Array<{ __typename?: 'UploadPath', path: string, mime: string, original_name?: string | null }>, source: { __typename?: 'EmailChannel', address?: string | null, folder?: string | null } | { __typename?: 'HttpChannel', endpoint?: string | null, source_address?: string | null } | { __typename?: 'NetworkShareChannel', paths: Array<string> } | { __typename?: 'OtherChannel', channel_name: string, metadata?: string | null } };

export type DocumentFragmentFragment = { __typename?: 'Document', id: string, scope: Scope, created: Date, updated: Date, organization_id: string, document_class_identifier: string, storage_subdir: string, metadata?: object | null, title?: string | null, comments?: string | null, state: DocumentState, parent_document_id?: string | null, root_document_id: string, verification_sent?: boolean | null, locked: boolean, locked_by?: string | null, locked_at?: Date | null, locked_until?: Date | null, snoozed_at?: Date | null, topic: string, source?: SourceChannel | null, snooze_tag_users?: Array<string> | null, parent_upload?: { __typename?: 'Upload', received_at: Date, title?: string | null, content_preview?: string | null, identifier_by_organization?: string | null, paths: Array<{ __typename?: 'UploadPath', path: string, mime: string, original_name?: string | null }>, source: { __typename?: 'EmailChannel', address?: string | null, folder?: string | null } | { __typename?: 'HttpChannel', endpoint?: string | null, source_address?: string | null } | { __typename?: 'NetworkShareChannel', paths: Array<string> } | { __typename?: 'OtherChannel', channel_name: string, metadata?: string | null } } | null, pages: Array<{ __typename?: 'Page', pdf_path: string, thumbnail_path: string, display_path?: string | null, index_in_pdf: number, png_path: string }>, parent_document?: { __typename?: 'Document', id: string, document_class_identifier: string, state: DocumentState } | null, root_document?: { __typename?: 'Document', id: string, source?: SourceChannel | null, state: DocumentState, parent_upload?: { __typename?: 'Upload', title?: string | null, identifier_by_organization?: string | null, content_preview?: string | null, paths: Array<{ __typename?: 'UploadPath', original_name?: string | null }> } | null } | null, children?: Array<{ __typename?: 'Document', id: string }> | null, document_class?: { __typename?: 'DocumentClass', identifier: string, display_name: string } | null };

export type PredictedPageFragment = { __typename?: 'PredictedPage', source_page: number, transforms?: Array<{ __typename?: 'ImageTransform', axisAlignedRectangle?: { __typename?: 'AxisAlignedRectangle', x: number, y: number, width: number, height: number } | null, rotatedRectangle?: { __typename?: 'RotatedRectangle', width: number, height: number, centerX: number, centerY: number, angle: number } | null, perspectiveTransformation?: { __typename?: 'PerspectiveTransformation', matrix: Array<number>, size: Array<number> } | null, rotation?: { __typename?: 'Rotation', angle: number } | null }> | null };

export type FullDocumentFragmentFragment = { __typename?: 'Document', document_value?: string | null, snooze_comment?: string | null, snoozed_by?: string | null, id: string, scope: Scope, created: Date, updated: Date, organization_id: string, document_class_identifier: string, storage_subdir: string, metadata?: object | null, title?: string | null, comments?: string | null, state: DocumentState, parent_document_id?: string | null, root_document_id: string, verification_sent?: boolean | null, locked: boolean, locked_by?: string | null, locked_at?: Date | null, locked_until?: Date | null, snoozed_at?: Date | null, topic: string, source?: SourceChannel | null, snooze_tag_users?: Array<string> | null, children?: Array<{ __typename?: 'Document', id: string, title?: string | null, state: DocumentState, document_class?: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string } | null }> | null, document_class?: { __typename?: 'DocumentClass', identifier: string, display_name: string, local_identifier: string, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, parent_id?: string | null, selection_mode: SelectionMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null } | null, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, value?: string | null, pages: Array<{ __typename?: 'PredictedPage', source_page: number, transforms?: Array<{ __typename?: 'ImageTransform', axisAlignedRectangle?: { __typename?: 'AxisAlignedRectangle', x: number, y: number, width: number, height: number } | null, rotatedRectangle?: { __typename?: 'RotatedRectangle', width: number, height: number, centerX: number, centerY: number, angle: number } | null, perspectiveTransformation?: { __typename?: 'PerspectiveTransformation', matrix: Array<number>, size: Array<number> } | null, rotation?: { __typename?: 'Rotation', angle: number } | null }> | null }>, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, value?: string | null, pages: Array<{ __typename?: 'PredictedPage', source_page: number, transforms?: Array<{ __typename?: 'ImageTransform', axisAlignedRectangle?: { __typename?: 'AxisAlignedRectangle', x: number, y: number, width: number, height: number } | null, rotatedRectangle?: { __typename?: 'RotatedRectangle', width: number, height: number, centerX: number, centerY: number, angle: number } | null, perspectiveTransformation?: { __typename?: 'PerspectiveTransformation', matrix: Array<number>, size: Array<number> } | null, rotation?: { __typename?: 'Rotation', angle: number } | null }> | null }>, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, value?: string | null, pages: Array<{ __typename?: 'PredictedPage', source_page: number, transforms?: Array<{ __typename?: 'ImageTransform', axisAlignedRectangle?: { __typename?: 'AxisAlignedRectangle', x: number, y: number, width: number, height: number } | null, rotatedRectangle?: { __typename?: 'RotatedRectangle', width: number, height: number, centerX: number, centerY: number, angle: number } | null, perspectiveTransformation?: { __typename?: 'PerspectiveTransformation', matrix: Array<number>, size: Array<number> } | null, rotation?: { __typename?: 'Rotation', angle: number } | null }> | null }>, prediction?: { __typename?: 'Prediction', id: string } | null }> }> } | null }> }> } | null }> }> } | null, parent_upload?: { __typename?: 'Upload', received_at: Date, title?: string | null, content_preview?: string | null, identifier_by_organization?: string | null, paths: Array<{ __typename?: 'UploadPath', path: string, mime: string, original_name?: string | null }>, source: { __typename?: 'EmailChannel', address?: string | null, folder?: string | null } | { __typename?: 'HttpChannel', endpoint?: string | null, source_address?: string | null } | { __typename?: 'NetworkShareChannel', paths: Array<string> } | { __typename?: 'OtherChannel', channel_name: string, metadata?: string | null } } | null, pages: Array<{ __typename?: 'Page', pdf_path: string, thumbnail_path: string, display_path?: string | null, index_in_pdf: number, png_path: string }>, parent_document?: { __typename?: 'Document', id: string, document_class_identifier: string, state: DocumentState } | null, root_document?: { __typename?: 'Document', id: string, source?: SourceChannel | null, state: DocumentState, parent_upload?: { __typename?: 'Upload', title?: string | null, identifier_by_organization?: string | null, content_preview?: string | null, paths: Array<{ __typename?: 'UploadPath', original_name?: string | null }> } | null } | null };

export type DocumentsQueryVariables = Exact<{
  filter: DocumentFilter;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<DocumentSort> | DocumentSort>;
}>;


export type DocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'DocumentEdge', cursor: any, node: { __typename?: 'Document', id: string, scope: Scope, created: Date, updated: Date, organization_id: string, document_class_identifier: string, storage_subdir: string, metadata?: object | null, title?: string | null, comments?: string | null, state: DocumentState, parent_document_id?: string | null, root_document_id: string, verification_sent?: boolean | null, locked: boolean, locked_by?: string | null, locked_at?: Date | null, locked_until?: Date | null, snoozed_at?: Date | null, topic: string, source?: SourceChannel | null, snooze_tag_users?: Array<string> | null, parent_upload?: { __typename?: 'Upload', received_at: Date, title?: string | null, content_preview?: string | null, identifier_by_organization?: string | null, paths: Array<{ __typename?: 'UploadPath', path: string, mime: string, original_name?: string | null }>, source: { __typename?: 'EmailChannel', address?: string | null, folder?: string | null } | { __typename?: 'HttpChannel', endpoint?: string | null, source_address?: string | null } | { __typename?: 'NetworkShareChannel', paths: Array<string> } | { __typename?: 'OtherChannel', channel_name: string, metadata?: string | null } } | null, pages: Array<{ __typename?: 'Page', pdf_path: string, thumbnail_path: string, display_path?: string | null, index_in_pdf: number, png_path: string }>, parent_document?: { __typename?: 'Document', id: string, document_class_identifier: string, state: DocumentState } | null, root_document?: { __typename?: 'Document', id: string, source?: SourceChannel | null, state: DocumentState, parent_upload?: { __typename?: 'Upload', title?: string | null, identifier_by_organization?: string | null, content_preview?: string | null, paths: Array<{ __typename?: 'UploadPath', original_name?: string | null }> } | null } | null, children?: Array<{ __typename?: 'Document', id: string }> | null, document_class?: { __typename?: 'DocumentClass', identifier: string, display_name: string } | null } }> } };

export type DocumentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', document_value?: string | null, snooze_comment?: string | null, snoozed_by?: string | null, id: string, scope: Scope, created: Date, updated: Date, organization_id: string, document_class_identifier: string, storage_subdir: string, metadata?: object | null, title?: string | null, comments?: string | null, state: DocumentState, parent_document_id?: string | null, root_document_id: string, verification_sent?: boolean | null, locked: boolean, locked_by?: string | null, locked_at?: Date | null, locked_until?: Date | null, snoozed_at?: Date | null, topic: string, source?: SourceChannel | null, snooze_tag_users?: Array<string> | null, children?: Array<{ __typename?: 'Document', id: string, title?: string | null, state: DocumentState, document_class?: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string } | null }> | null, document_class?: { __typename?: 'DocumentClass', identifier: string, display_name: string, local_identifier: string, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, parent_id?: string | null, selection_mode: SelectionMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null } | null, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, value?: string | null, pages: Array<{ __typename?: 'PredictedPage', source_page: number, transforms?: Array<{ __typename?: 'ImageTransform', axisAlignedRectangle?: { __typename?: 'AxisAlignedRectangle', x: number, y: number, width: number, height: number } | null, rotatedRectangle?: { __typename?: 'RotatedRectangle', width: number, height: number, centerX: number, centerY: number, angle: number } | null, perspectiveTransformation?: { __typename?: 'PerspectiveTransformation', matrix: Array<number>, size: Array<number> } | null, rotation?: { __typename?: 'Rotation', angle: number } | null }> | null }>, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, value?: string | null, pages: Array<{ __typename?: 'PredictedPage', source_page: number, transforms?: Array<{ __typename?: 'ImageTransform', axisAlignedRectangle?: { __typename?: 'AxisAlignedRectangle', x: number, y: number, width: number, height: number } | null, rotatedRectangle?: { __typename?: 'RotatedRectangle', width: number, height: number, centerX: number, centerY: number, angle: number } | null, perspectiveTransformation?: { __typename?: 'PerspectiveTransformation', matrix: Array<number>, size: Array<number> } | null, rotation?: { __typename?: 'Rotation', angle: number } | null }> | null }>, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, value?: string | null, pages: Array<{ __typename?: 'PredictedPage', source_page: number, transforms?: Array<{ __typename?: 'ImageTransform', axisAlignedRectangle?: { __typename?: 'AxisAlignedRectangle', x: number, y: number, width: number, height: number } | null, rotatedRectangle?: { __typename?: 'RotatedRectangle', width: number, height: number, centerX: number, centerY: number, angle: number } | null, perspectiveTransformation?: { __typename?: 'PerspectiveTransformation', matrix: Array<number>, size: Array<number> } | null, rotation?: { __typename?: 'Rotation', angle: number } | null }> | null }>, prediction?: { __typename?: 'Prediction', id: string } | null }> }> } | null }> }> } | null }> }> } | null, parent_upload?: { __typename?: 'Upload', received_at: Date, title?: string | null, content_preview?: string | null, identifier_by_organization?: string | null, paths: Array<{ __typename?: 'UploadPath', path: string, mime: string, original_name?: string | null }>, source: { __typename?: 'EmailChannel', address?: string | null, folder?: string | null } | { __typename?: 'HttpChannel', endpoint?: string | null, source_address?: string | null } | { __typename?: 'NetworkShareChannel', paths: Array<string> } | { __typename?: 'OtherChannel', channel_name: string, metadata?: string | null } } | null, pages: Array<{ __typename?: 'Page', pdf_path: string, thumbnail_path: string, display_path?: string | null, index_in_pdf: number, png_path: string }>, parent_document?: { __typename?: 'Document', id: string, document_class_identifier: string, state: DocumentState } | null, root_document?: { __typename?: 'Document', id: string, source?: SourceChannel | null, state: DocumentState, parent_upload?: { __typename?: 'Upload', title?: string | null, identifier_by_organization?: string | null, content_preview?: string | null, paths: Array<{ __typename?: 'UploadPath', original_name?: string | null }> } | null } | null } | null };

export type DocumentsSameRootQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DocumentsSameRootQuery = { __typename?: 'Query', document?: { __typename?: 'Document', documents?: Array<{ __typename?: 'Document', state: DocumentState, id: string, parent_document_id?: string | null, document_class?: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, identifier_by_organization?: string | null, display_name: string, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, parent_id?: string | null, selection_mode: SelectionMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null } | null }> | null } | null };

export type CountDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<DocumentFilter>;
}>;


export type CountDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', totalCount: number } };

export type CreatedDocumentSubscriptionVariables = Exact<{
  filter: DocumentSubscriptionFilter;
}>;


export type CreatedDocumentSubscription = { __typename?: 'Subscription', createdDocument: { __typename?: 'Document', id: string, scope: Scope, created: Date, updated: Date, organization_id: string, document_class_identifier: string, storage_subdir: string, metadata?: object | null, title?: string | null, comments?: string | null, state: DocumentState, parent_document_id?: string | null, root_document_id: string, verification_sent?: boolean | null, locked: boolean, locked_by?: string | null, locked_at?: Date | null, locked_until?: Date | null, snoozed_at?: Date | null, topic: string, source?: SourceChannel | null, snooze_tag_users?: Array<string> | null, parent_upload?: { __typename?: 'Upload', received_at: Date, title?: string | null, content_preview?: string | null, identifier_by_organization?: string | null, paths: Array<{ __typename?: 'UploadPath', path: string, mime: string, original_name?: string | null }>, source: { __typename?: 'EmailChannel', address?: string | null, folder?: string | null } | { __typename?: 'HttpChannel', endpoint?: string | null, source_address?: string | null } | { __typename?: 'NetworkShareChannel', paths: Array<string> } | { __typename?: 'OtherChannel', channel_name: string, metadata?: string | null } } | null, pages: Array<{ __typename?: 'Page', pdf_path: string, thumbnail_path: string, display_path?: string | null, index_in_pdf: number, png_path: string }>, parent_document?: { __typename?: 'Document', id: string, document_class_identifier: string, state: DocumentState } | null, root_document?: { __typename?: 'Document', id: string, source?: SourceChannel | null, state: DocumentState, parent_upload?: { __typename?: 'Upload', title?: string | null, identifier_by_organization?: string | null, content_preview?: string | null, paths: Array<{ __typename?: 'UploadPath', original_name?: string | null }> } | null } | null, children?: Array<{ __typename?: 'Document', id: string }> | null, document_class?: { __typename?: 'DocumentClass', identifier: string, display_name: string } | null } };

export type DeletedOneDocumentSubscriptionVariables = Exact<{
  filter: DocumentSubscriptionFilter;
}>;


export type DeletedOneDocumentSubscription = { __typename?: 'Subscription', deletedOneDocument: { __typename?: 'DocumentDeleteResponse', id?: string | null, created?: Date | null, updated?: Date | null } };

export type UpdatedOneDocumentSubscriptionVariables = Exact<{
  filter: DocumentSubscriptionFilter;
}>;


export type UpdatedOneDocumentSubscription = { __typename?: 'Subscription', updatedOneDocument: { __typename?: 'Document', id: string, scope: Scope, created: Date, updated: Date, organization_id: string, document_class_identifier: string, storage_subdir: string, metadata?: object | null, title?: string | null, comments?: string | null, state: DocumentState, parent_document_id?: string | null, root_document_id: string, verification_sent?: boolean | null, locked: boolean, locked_by?: string | null, locked_at?: Date | null, locked_until?: Date | null, snoozed_at?: Date | null, topic: string, source?: SourceChannel | null, snooze_tag_users?: Array<string> | null, pages: Array<{ __typename?: 'Page', index_in_pdf: number }>, parent_document?: { __typename?: 'Document', id: string, document_class_identifier: string, state: DocumentState } | null, root_document?: { __typename?: 'Document', id: string, source?: SourceChannel | null, state: DocumentState } | null, children?: Array<{ __typename?: 'Document', id: string }> | null, document_class?: { __typename?: 'DocumentClass', identifier: string, display_name: string } | null } };

export type TriggerForcedDocumentStateChangeMutationVariables = Exact<{
  document_ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  desired_state: DocumentState;
}>;


export type TriggerForcedDocumentStateChangeMutation = { __typename?: 'Mutation', forceDocumentStateChange: Array<string> };

export type SoftDeleteDocumentsMutationVariables = Exact<{
  document_ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SoftDeleteDocumentsMutation = { __typename?: 'Mutation', softDeleteDocuments: Array<string> };

export type LockOneDocumentMutationVariables = Exact<{
  document_id: Scalars['String'];
}>;


export type LockOneDocumentMutation = { __typename?: 'Mutation', lockOneDocument: boolean };

export type UnlockOneDocumentMutationVariables = Exact<{
  document_id: Scalars['String'];
}>;


export type UnlockOneDocumentMutation = { __typename?: 'Mutation', unlockOneDocument: boolean };

export type SnoozeDocumentMutationVariables = Exact<{
  document_id: Scalars['String'];
  snooze_comment?: InputMaybe<Scalars['String']>;
  snooze_tag_users?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SnoozeDocumentMutation = { __typename?: 'Mutation', snoozeDocument: boolean };

export type UnsnoozeDocumentMutationVariables = Exact<{
  document_id: Scalars['String'];
}>;


export type UnsnoozeDocumentMutation = { __typename?: 'Mutation', unsnoozeDocument: boolean };

export type MarkExportVerificationSentMutationVariables = Exact<{
  document_id: Scalars['String'];
}>;


export type MarkExportVerificationSentMutation = { __typename?: 'Mutation', markExportVerificationSent: boolean };

export type RequestVerificationRetryMutationVariables = Exact<{
  document_ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RequestVerificationRetryMutation = { __typename?: 'Mutation', requestVerificationRetry: Array<string> };

export type UpdateOneDocumentInformationMutationVariables = Exact<{
  document_id: Scalars['String'];
  update_input: DocumentInformationUpdateInput;
}>;


export type UpdateOneDocumentInformationMutation = { __typename?: 'Mutation', updateOneDocumentInformation: string };

export type GetAllDocumentCountsMutationVariables = Exact<{
  scope: Scope;
}>;


export type GetAllDocumentCountsMutation = { __typename?: 'Mutation', getAllDocumentCounts: Array<{ __typename?: 'MenuEntryCount', identifier: string, count: number, tag_count: number, snoozed_count: number, regex?: string | null }> };

export type CreatePredictionMutationVariables = Exact<{
  predictionInput: PredictionInput;
  document_id: Scalars['String'];
}>;


export type CreatePredictionMutation = { __typename?: 'Mutation', createPrediction: string };

export type PredictionFragment = { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, pages: Array<{ __typename?: 'PredictedPage', source_page: number }>, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, pages: Array<{ __typename?: 'PredictedPage', source_page: number }> }> }> } | null }> }> };

export type PredictionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PredictionQuery = { __typename?: 'Query', prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, user_id?: string | null, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, pages: Array<{ __typename?: 'PredictedPage', source_page: number }>, prediction?: { __typename?: 'Prediction', id: string, confirmedness: number, source: string, candidates: Array<{ __typename?: 'PredictionCandidate', id: string, score: number, documents: Array<{ __typename?: 'PredictedDocument', id: string, confidence: number, document_class_identifier: string, pages: Array<{ __typename?: 'PredictedPage', source_page: number }> }> }> } | null }> }> } | null };

export type CountTotalDocumentsQueryVariables = Exact<{
  filter: DocumentFilter;
  step: TimeStep;
  sortfield?: InputMaybe<DocumentSort>;
}>;


export type CountTotalDocumentsQuery = { __typename?: 'Query', countTotalDocuments: Array<{ __typename?: 'SimplePoint', y: number, x: Date }> };

export type CountDocumentsByClassQueryVariables = Exact<{
  filter: DocumentFilter;
  step: TimeStep;
  sortfield?: InputMaybe<DocumentSort>;
}>;


export type CountDocumentsByClassQuery = { __typename?: 'Query', countDocumentsByClass: Array<{ __typename?: 'DocumentTypeSeries', y: Array<number>, x: Array<Date>, total: number, document_class_identifier: string }> };

export const UploadFragmentFragmentDoc = gql`
    fragment uploadFragment on Upload {
  paths {
    path
    mime
    original_name
  }
  received_at
  title
  content_preview
  source {
    ... on NetworkShareChannel {
      paths
    }
    ... on HttpChannel {
      endpoint
      source_address
    }
    ... on EmailChannel {
      address
      folder
    }
    ... on OtherChannel {
      channel_name
      metadata
    }
  }
  identifier_by_organization
}
    `;
export const PageFragmentFragmentDoc = gql`
    fragment pageFragment on Page {
  pdf_path
  thumbnail_path
  display_path
  index_in_pdf
  png_path
}
    `;
export const DocumentFragmentFragmentDoc = gql`
    fragment documentFragment on Document {
  id
  scope
  parent_upload {
    ...uploadFragment
  }
  created
  updated
  organization_id
  scope
  document_class_identifier
  storage_subdir
  pages {
    ...pageFragment
  }
  metadata
  title
  comments
  state
  parent_document_id
  root_document_id
  verification_sent
  locked
  locked_by
  locked_at
  locked_until
  snoozed_at
  parent_document {
    id
    document_class_identifier
    state
  }
  root_document {
    id
    parent_upload {
      title
      identifier_by_organization
      content_preview
      paths {
        original_name
      }
    }
    source
    state
  }
  children {
    id
  }
  document_class {
    identifier
    display_name
  }
  topic
  source
  snooze_tag_users
}
    ${UploadFragmentFragmentDoc}
${PageFragmentFragmentDoc}`;
export const FrontendDocumentClassFragmentFragmentDoc = gql`
    fragment frontendDocumentClassFragment on DocumentClass {
  identifier
  local_identifier
  identifier_by_organization
  display_name
  organization_id
  description
  auto_predictor_mode
  parent_id
  selection_mode
  possible_value
  min_count
  max_count
  min_page_count
  max_page_count
  may_overlap_with_siblings
  order_weight
  blind_processing_thresholds {
    confirmedness
    score
  }
  always_include_in_blind_processing_decision
  export_enabled
  comments
  created
  updated
  category
  deleted_at
  export_timeout
  export_parallelization
  export_queue
  prediction_queue
  search_keywords
}
    `;
export const PredictedPageFragmentDoc = gql`
    fragment predictedPage on PredictedPage {
  source_page
  transforms {
    axisAlignedRectangle {
      x
      y
      width
      height
    }
    rotatedRectangle {
      width
      height
      centerX
      centerY
      angle
    }
    perspectiveTransformation {
      matrix
      size
    }
    rotation {
      angle
    }
  }
}
    `;
export const FullDocumentFragmentFragmentDoc = gql`
    fragment fullDocumentFragment on Document {
  ...documentFragment
  children {
    id
    title
    state
    document_class {
      identifier
      local_identifier
      display_name
    }
  }
  document_class {
    ...frontendDocumentClassFragment
  }
  document_value
  snooze_comment
  snoozed_by
  prediction {
    id
    confirmedness
    source
    user_id
    candidates {
      id
      score
      documents {
        id
        confidence
        document_class_identifier
        pages {
          ...predictedPage
        }
        value
        prediction {
          id
          confirmedness
          source
          user_id
          candidates {
            id
            score
            documents {
              id
              confidence
              document_class_identifier
              pages {
                ...predictedPage
              }
              prediction {
                id
                confirmedness
                source
                user_id
                candidates {
                  id
                  score
                  documents {
                    id
                    confidence
                    document_class_identifier
                    pages {
                      ...predictedPage
                    }
                    prediction {
                      id
                    }
                    value
                  }
                }
              }
              value
            }
          }
        }
      }
    }
  }
}
    ${DocumentFragmentFragmentDoc}
${FrontendDocumentClassFragmentFragmentDoc}
${PredictedPageFragmentDoc}`;
export const PredictionFragmentDoc = gql`
    fragment prediction on Prediction {
  id
  confirmedness
  source
  user_id
  candidates {
    id
    score
    documents {
      id
      confidence
      document_class_identifier
      pages {
        source_page
      }
      prediction {
        id
        confirmedness
        source
        candidates {
          id
          score
          documents {
            id
            confidence
            document_class_identifier
            pages {
              source_page
            }
          }
        }
      }
    }
  }
}
    `;
export const DocumentsDocument = gql`
    query documents($filter: DocumentFilter!, $paging: CursorPaging, $sorting: [DocumentSort!]) {
  documents(filter: $filter, paging: $paging, sorting: $sorting) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...documentFragment
      }
    }
  }
}
    ${DocumentFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsGQL extends Apollo.Query<DocumentsQuery, DocumentsQueryVariables> {
    override document = DocumentsDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentDocument = gql`
    query document($id: String!) {
  document(id: $id) {
    ...fullDocumentFragment
  }
}
    ${FullDocumentFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentGQL extends Apollo.Query<DocumentQuery, DocumentQueryVariables> {
    override document = DocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsSameRootDocument = gql`
    query documentsSameRoot($id: String!) {
  document(id: $id) {
    documents {
      state
      id
      parent_document_id
      document_class {
        ...frontendDocumentClassFragment
      }
    }
  }
}
    ${FrontendDocumentClassFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsSameRootGQL extends Apollo.Query<DocumentsSameRootQuery, DocumentsSameRootQueryVariables> {
    override document = DocumentsSameRootDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountDocumentsDocument = gql`
    query countDocuments($filter: DocumentFilter) {
  documents(filter: $filter) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountDocumentsGQL extends Apollo.Query<CountDocumentsQuery, CountDocumentsQueryVariables> {
    override document = CountDocumentsDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatedDocumentDocument = gql`
    subscription createdDocument($filter: DocumentSubscriptionFilter!) {
  createdDocument(input: {filter: $filter}) {
    ...documentFragment
  }
}
    ${DocumentFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatedDocumentGQL extends Apollo.Subscription<CreatedDocumentSubscription, CreatedDocumentSubscriptionVariables> {
    override document = CreatedDocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletedOneDocumentDocument = gql`
    subscription deletedOneDocument($filter: DocumentSubscriptionFilter!) {
  deletedOneDocument(input: {filter: $filter}) {
    id
    created
    updated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletedOneDocumentGQL extends Apollo.Subscription<DeletedOneDocumentSubscription, DeletedOneDocumentSubscriptionVariables> {
    override document = DeletedOneDocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatedOneDocumentDocument = gql`
    subscription updatedOneDocument($filter: DocumentSubscriptionFilter!) {
  updatedOneDocument(input: {filter: $filter}) {
    id
    scope
    created
    updated
    organization_id
    scope
    document_class_identifier
    storage_subdir
    pages {
      index_in_pdf
    }
    metadata
    title
    comments
    state
    parent_document_id
    root_document_id
    verification_sent
    locked
    locked_by
    locked_at
    locked_until
    snoozed_at
    parent_document {
      id
      document_class_identifier
      state
    }
    root_document {
      id
      source
      state
    }
    children {
      id
    }
    document_class {
      identifier
      display_name
    }
    topic
    source
    snooze_tag_users
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatedOneDocumentGQL extends Apollo.Subscription<UpdatedOneDocumentSubscription, UpdatedOneDocumentSubscriptionVariables> {
    override document = UpdatedOneDocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TriggerForcedDocumentStateChangeDocument = gql`
    mutation triggerForcedDocumentStateChange($document_ids: [String!], $desired_state: DocumentState!) {
  forceDocumentStateChange(
    filter: {id: {in: $document_ids}}
    desired_state: $desired_state
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TriggerForcedDocumentStateChangeGQL extends Apollo.Mutation<TriggerForcedDocumentStateChangeMutation, TriggerForcedDocumentStateChangeMutationVariables> {
    override document = TriggerForcedDocumentStateChangeDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SoftDeleteDocumentsDocument = gql`
    mutation softDeleteDocuments($document_ids: [String!]) {
  softDeleteDocuments(filter: {id: {in: $document_ids}})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SoftDeleteDocumentsGQL extends Apollo.Mutation<SoftDeleteDocumentsMutation, SoftDeleteDocumentsMutationVariables> {
    override document = SoftDeleteDocumentsDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LockOneDocumentDocument = gql`
    mutation lockOneDocument($document_id: String!) {
  lockOneDocument(document_id: $document_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LockOneDocumentGQL extends Apollo.Mutation<LockOneDocumentMutation, LockOneDocumentMutationVariables> {
    override document = LockOneDocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnlockOneDocumentDocument = gql`
    mutation unlockOneDocument($document_id: String!) {
  unlockOneDocument(document_id: $document_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnlockOneDocumentGQL extends Apollo.Mutation<UnlockOneDocumentMutation, UnlockOneDocumentMutationVariables> {
    override document = UnlockOneDocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SnoozeDocumentDocument = gql`
    mutation snoozeDocument($document_id: String!, $snooze_comment: String, $snooze_tag_users: [String!]) {
  snoozeDocument(
    document_id: $document_id
    snooze_comment: $snooze_comment
    snooze_tag_users: $snooze_tag_users
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SnoozeDocumentGQL extends Apollo.Mutation<SnoozeDocumentMutation, SnoozeDocumentMutationVariables> {
    override document = SnoozeDocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnsnoozeDocumentDocument = gql`
    mutation unsnoozeDocument($document_id: String!) {
  unsnoozeDocument(document_id: $document_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnsnoozeDocumentGQL extends Apollo.Mutation<UnsnoozeDocumentMutation, UnsnoozeDocumentMutationVariables> {
    override document = UnsnoozeDocumentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkExportVerificationSentDocument = gql`
    mutation markExportVerificationSent($document_id: String!) {
  markExportVerificationSent(document_id: $document_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkExportVerificationSentGQL extends Apollo.Mutation<MarkExportVerificationSentMutation, MarkExportVerificationSentMutationVariables> {
    override document = MarkExportVerificationSentDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestVerificationRetryDocument = gql`
    mutation requestVerificationRetry($document_ids: [String!]) {
  requestVerificationRetry(filter: {id: {in: $document_ids}})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestVerificationRetryGQL extends Apollo.Mutation<RequestVerificationRetryMutation, RequestVerificationRetryMutationVariables> {
    override document = RequestVerificationRetryDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOneDocumentInformationDocument = gql`
    mutation updateOneDocumentInformation($document_id: String!, $update_input: DocumentInformationUpdateInput!) {
  updateOneDocumentInformation(document_id: $document_id, update: $update_input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOneDocumentInformationGQL extends Apollo.Mutation<UpdateOneDocumentInformationMutation, UpdateOneDocumentInformationMutationVariables> {
    override document = UpdateOneDocumentInformationDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDocumentCountsDocument = gql`
    mutation getAllDocumentCounts($scope: Scope!) {
  getAllDocumentCounts(scope: $scope) {
    identifier
    count
    tag_count
    snoozed_count
    regex
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDocumentCountsGQL extends Apollo.Mutation<GetAllDocumentCountsMutation, GetAllDocumentCountsMutationVariables> {
    override document = GetAllDocumentCountsDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePredictionDocument = gql`
    mutation createPrediction($predictionInput: PredictionInput!, $document_id: String!) {
  createPrediction(predictionInput: $predictionInput, document_id: $document_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePredictionGQL extends Apollo.Mutation<CreatePredictionMutation, CreatePredictionMutationVariables> {
    override document = CreatePredictionDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PredictionDocument = gql`
    query Prediction($id: String!) {
  prediction(id: $id) {
    ...prediction
  }
}
    ${PredictionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PredictionGQL extends Apollo.Query<PredictionQuery, PredictionQueryVariables> {
    override document = PredictionDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountTotalDocumentsDocument = gql`
    query countTotalDocuments($filter: DocumentFilter!, $step: TimeStep!, $sortfield: DocumentSort) {
  countTotalDocuments(filter: $filter, step: $step, sortfield: $sortfield) {
    y
    x
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountTotalDocumentsGQL extends Apollo.Query<CountTotalDocumentsQuery, CountTotalDocumentsQueryVariables> {
    override document = CountTotalDocumentsDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountDocumentsByClassDocument = gql`
    query countDocumentsByClass($filter: DocumentFilter!, $step: TimeStep!, $sortfield: DocumentSort) {
  countDocumentsByClass(filter: $filter, step: $step, sortfield: $sortfield) {
    y
    x
    total
    document_class_identifier
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountDocumentsByClassGQL extends Apollo.Query<CountDocumentsByClassQuery, CountDocumentsByClassQueryVariables> {
    override document = CountDocumentsByClassDocument;
    override client = 'frontend';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }